/* eslint-disable no-underscore-dangle */
WYATT.registerComponent(
  "back-in-stock",
  class BackInStock extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector("form");

      this.form.addEventListener("submit", this.handleSubmit.bind(this));
    }

    handleSubmit(event) {
      const data = this.getFormData();

      event.preventDefault();

      if (window._ltk === undefined) {
        this.close();
        WYATT.createMessage("error", WYATT.t.backInStock.errorMessage);

        return;
      }

      window._ltk.Alerts.AddAlertWithIdentifiers(data);
      window._ltk.Alerts.Submit();

      this.close();
      WYATT.createMessage("success", WYATT.t.backInStock.successMessage);
    }

    close() {
      this.closest("dialog").close();
    }

    getFormData() {
      const data = new FormData(this.form);

      return {
        Identifiers: {
          Email: data.get("email"),
          PhoneNumber: data.get("phone"),
        },
        Sku: data.get("id"),
        AlertCode: data.get("alert-code"),
      };
    }
  }
);
